import { TemplateItem } from './StoresFunnelChooseTemplate.data'

const FASHION_APPAREL: TemplateItem[] = [
  {
    templateId: '0dfab833-b158-47c8-9de0-639a51efc1ef',
    title: 'Swimwear Store',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/d015a59863f15a2e492409286278d5e35fa6f3760fd2dde8a2269d32eb9b1c631638203725016.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/d015a59863f15a2e492409286278d5e35fa6f3760fd2dde8a2269d32eb9b1c631638203725016.webp',
  },
  {
    templateId: '92474928-1382-4a77-997d-40c2f72c8bea',
    title: 'Clothing Store',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/c69b9418433b9f0a8f4f23a268e9962bbc53a0d57d8808e3eaa89986d339ec35.jpg/v1/fill/w_3840%2Ch_2160%2Cal_c%2Cq_90/c69b9418433b9f0a8f4f23a268e9962bbc53a0d57d8808e3eaa89986d339ec35.webp',
  },
  {
    templateId: '8cba5ea4-fef2-4d9d-b893-e279d231934b',
    title: 'Fashion Stylist',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/0aaa6890da24a5e0987dd0f5484f4fff30757edd11d0014d1c1e433d2314b44f.jpg/v1/fill/w_3840%2Ch_2160%2Cal_c%2Cq_90/0aaa6890da24a5e0987dd0f5484f4fff30757edd11d0014d1c1e433d2314b44f.webp',
  },
  {
    templateId: '2b53e6b0-5e04-40c5-9bd4-f7ee7eaee483',
    title: 'Clothing Store',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/27b33f357a6676ec63f004670b708792478c62ededaa49c1e30e818c031a57c8.jpg/v1/fill/w_3840%2Ch_2160%2Cal_c%2Cq_90/27b33f357a6676ec63f004670b708792478c62ededaa49c1e30e818c031a57c8.webp',
  },
  {
    templateId: 'd74e8fd5-924e-47f7-ab48-e81dc41e1761',
    title: 'T-Shirt Store',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/383f98fdc87ad4edf94796aa248d7307d2c4444ac0c170ee75daa5119179c6d51626874518992.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/383f98fdc87ad4edf94796aa248d7307d2c4444ac0c170ee75daa5119179c6d51626874518992.webp',
  },
  {
    templateId: '4fcd770d-ab1c-4530-ada2-1920b43d7925',
    title: 'Clothing Store',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/7207ffbc19be1a77a84e50f960a12683e1a2b4976a22316e9a3408f62baf9df71594561698267.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/7207ffbc19be1a77a84e50f960a12683e1a2b4976a22316e9a3408f62baf9df71594561698267.webp',
  },
]

const BEAUTY_AND_HAIR: TemplateItem[] = [
  {
    templateId: '3e5bcf77-3450-4dd8-8e3d-ab0d190d63fd',
    title: 'Beauty and Co Salon',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/ce9f21cef61b39fc381eb785f3ad2474864d67df8bd075a9773d346189d3fddd1683020463686.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/ce9f21cef61b39fc381eb785f3ad2474864d67df8bd075a9773d346189d3fddd1683020463686.webp',
  },
  {
    templateId: '807df013-fefb-411b-a721-bd658a2bd789',
    title: 'Beauty Salon',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/f183eb067d2650289bec60b46585af354a2fac38d3200f56df571deb3bb5ed021675846717821.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/f183eb067d2650289bec60b46585af354a2fac38d3200f56df571deb3bb5ed021675846717821.webp',
  },
  {
    templateId: 'f379b538-cbea-4148-a7f2-ae87a763b3cf',
    title: 'Bridal Beauty Salon',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/f267834e24e91931957bb776bbe9458b7064324818178d950099e16d309d94b61701955768017.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/f267834e24e91931957bb776bbe9458b7064324818178d950099e16d309d94b61701955768017.webp',
  },
  {
    templateId: '09e4f29a-9c5c-4f4b-b7b2-c594ed4745f5',
    title: 'Beauty Technician',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/f5ac4020842d01a275c58f7776a16a110f46e246deb570324c5e86add9451269.jpg/v1/fill/w_3840%2Ch_2160%2Cal_c%2Cq_90/f5ac4020842d01a275c58f7776a16a110f46e246deb570324c5e86add9451269.webp',
  },
  {
    templateId: 'a23e8e18-4a99-4d8b-adff-b45ac27a9d92',
    title: 'Pastel Beauty Salon',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/930c7858f25ab4b509c2c7642926e551ce31d5ab621f3d49e6251daed6cd8c511683021255495.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/930c7858f25ab4b509c2c7642926e551ce31d5ab621f3d49e6251daed6cd8c511683021255495.webp',
  },
  {
    templateId: '71ddcdbb-818c-4c6f-ad65-40769a65983b',
    title: 'Barbershop',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/4f265ecb78f828b1a740a4f0780ceb37ca1d9a969f964228cb7a8f98fc4dcc67.jpg/v1/fill/w_3840%2Ch_2160%2Cal_c%2Cq_90/4f265ecb78f828b1a740a4f0780ceb37ca1d9a969f964228cb7a8f98fc4dcc67.webp',
  },
]

const HOME_LIVING: TemplateItem[] = [
  {
    templateId: 'bf469b71-2eb4-4d7b-9ce1-c932c7d8cdcd',
    title: 'Vacation Rental Company',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/3526eeb4111679792cf2134e7fefa4fde27785655f0276695de1132ea53b15fc1678348134432.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/3526eeb4111679792cf2134e7fefa4fde27785655f0276695de1132ea53b15fc1678348134432.webp',
  },
  {
    templateId: '1dec3534-5e8f-4aa3-b2e5-5ef760cfc718',
    title: 'Vacation Rental Company',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/cd34c4adf075172f4d2b5896a5dbf25131a27fc8ffbac1b6a3313e248e7647881678347615526.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/cd34c4adf075172f4d2b5896a5dbf25131a27fc8ffbac1b6a3313e248e7647881678347615526.webp',
  },
  {
    templateId: '9854360d-1295-4253-a9d1-8691dafa0d58',
    title: 'Vacation Rental Company',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/d090c2f96fb08168784792db619feaf39c44b33cbaeef8ce361701861739a6b21678347528875.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/d090c2f96fb08168784792db619feaf39c44b33cbaeef8ce361701861739a6b21678347528875.webp',
  },
  {
    templateId: '5d5e3acc-b028-4c7f-8318-4ca5811ef415',
    title: 'Vacation Rental Company',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/86a3865c155d76571cfe5ae2da97cf629f599c644bda5aa6a4e74e421d8e94e81678348579973.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/86a3865c155d76571cfe5ae2da97cf629f599c644bda5aa6a4e74e421d8e94e81678348579973.webp',
  },
  {
    templateId: '9d5a8743-501e-4237-acff-6f5b9c2f6866',
    title: 'Hostel',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/e34da21034a9edc7d8136efb0658b74f50cb25ee4400871a0856a5f148819aca1678348883229.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/e34da21034a9edc7d8136efb0658b74f50cb25ee4400871a0856a5f148819aca1678348883229.webp',
  },
  {
    templateId: '9c06c15d-6bb3-42fe-b65d-d02b2d082dc8',
    title: 'Vacation Rental Company (Urban)',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates-thumbnail-manual-uploads/Vacation%20Rental%20Company%20(Urban)%20-%20Desktop.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/Vacation%20Rental%20Company%20(Urban)%20-%20Desktop.webp',
  },
]

const ELECTRONICS_GADGETS: TemplateItem[] = [
  {
    templateId: 'c1326a37-12dc-4406-89cb-00f0a2690f78',
    title: '3D Printing Company',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/2bbc661e93a26512b9aff129130e5f456869c4b2ea2274e076cae0a3445baae31625989921033.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/2bbc661e93a26512b9aff129130e5f456869c4b2ea2274e076cae0a3445baae31625989921033.webp',
  },
  {
    templateId: 'cdbf5aac-d797-404b-9002-efcc8db4b780',
    title: 'IT Services Company',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/1fe5a155025ae48862711b0c0f0af93957a22d0a64ab368cebc559f278655617.jpg/v1/fill/w_3840%2Ch_2160%2Cal_c%2Cq_90/1fe5a155025ae48862711b0c0f0af93957a22d0a64ab368cebc559f278655617.webp',
  },
  {
    templateId: '53985b39-c52f-4c84-92b5-3eb4d80bbb65',
    title: 'Tech Company',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/b347026042f10c7afa6dc252674e899654a8711ae642a7845a097f03cfd178b81670317628247.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/b347026042f10c7afa6dc252674e899654a8711ae642a7845a097f03cfd178b81670317628247.webp',
  },
  {
    templateId: 'edc05836-11a9-4b85-bb3c-bc8a81b52fb8',
    title: 'AI Company',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/3b2a97a89809eaf8ef1d0260365ec60296730f21c3f65e0026b4e884a0c1c7701622022079679.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/3b2a97a89809eaf8ef1d0260365ec60296730f21c3f65e0026b4e884a0c1c7701622022079679.webp',
  },
  {
    templateId: '06cfdf92-3e08-40f8-a4d3-6e04a5d45be8',
    title: 'Enterprise Solutions Company',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/f1d3e9e31d60b3529329c3d33b8e3363460ef8ae0cca4ef59985a053d2026f731622130162982.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/f1d3e9e31d60b3529329c3d33b8e3363460ef8ae0cca4ef59985a053d2026f731622130162982.webp',
  },
  {
    templateId: '24e45451-5cf6-4495-bb12-24fbad64a473',
    title: 'App Landing Page',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/09e926b98b2149c7ba461062b8a64f47.jpg/v1/fill/w_3840%2Ch_2160%2Cal_c%2Cq_90/09e926b98b2149c7ba461062b8a64f47.webp',
  },
]

const SPORTS_OUTDOORS: TemplateItem[] = [
  {
    templateId: '9c74ddcd-1d19-4bd3-84e4-82fa1db81dda',
    title: 'Sports Psychologist',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/9592b47bbcc48d78d307e300d33ed2692107f1e57c0125281031b66babd4a7aa1656336428145.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/9592b47bbcc48d78d307e300d33ed2692107f1e57c0125281031b66babd4a7aa1656336428145.webp',
  },
  {
    templateId: 'fc2af862-1197-4b3b-a1ac-a8f99ed571a2',
    title: 'Fitness Trainer',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/3f8e12eafef207aff61fe425ee70c7fb0f6a5ec981c65a527687c339a9bcc1841656336254820.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/3f8e12eafef207aff61fe425ee70c7fb0f6a5ec981c65a527687c339a9bcc1841656336254820.webp',
  },
  {
    templateId: 'c171f923-10f1-44c5-91d1-ba2306f145de',
    title: 'Pilates Studio',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/79189e96bd0f2f4c4f5c7305033166225182ca460fa026ed62b9e5f84b869dc41706700341742.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/79189e96bd0f2f4c4f5c7305033166225182ca460fa026ed62b9e5f84b869dc41706700341742.webp',
  },
  {
    templateId: 'e69f255d-79ed-4b3b-93e6-5ad5ebe8d73e',
    title: 'Fitness Studio',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/1cb339cf4deb03f2d3cb1d72ef69e91008f0d3d954b36f0fd56faf40b93d2cc91635234393113.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/1cb339cf4deb03f2d3cb1d72ef69e91008f0d3d954b36f0fd56faf40b93d2cc91635234393113.webp',
  },
  {
    templateId: '3fca5e2c-f5fb-48fe-b37c-413d86f63bb6',
    title: 'Sport Fitness Studio',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/3d4be32bd323e97c9ee1c8493962239ab7bacc1920e13264ecd20bf5d61575391635840107849.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/3d4be32bd323e97c9ee1c8493962239ab7bacc1920e13264ecd20bf5d61575391635840107849.webp',
  },
  {
    templateId: '1c65b4dd-32a0-488e-b0e4-67b870fbab13',
    title: 'Fitness Instructor',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/6ccd70ad570e1e4589a8708c44c83d282d13ed596115bf1e06bc998db5df9cf41656335687245.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/6ccd70ad570e1e4589a8708c44c83d282d13ed596115bf1e06bc998db5df9cf41656335687245.webp',
  },
]

const FOOD_BEVERAGES: TemplateItem[] = [
  {
    templateId: '8816221a-d300-4c9e-b075-41b012ebf7e5',
    title: 'Restaurant',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/4586686c2c98e87626e0b4dcf30f3bc7806792ab7e37513b0eb3c61a9b297bd11712482087505.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/4586686c2c98e87626e0b4dcf30f3bc7806792ab7e37513b0eb3c61a9b297bd11712482087505.webp',
  },
  {
    templateId: 'e391017a-ead6-43a7-bbb9-3d95347c40d9',
    title: 'Meat Restaurant',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/c8ac738dc67e92560ac38c805612751e6f0fcd5a2e26ec8655c6f733f79e37571721288657546.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/c8ac738dc67e92560ac38c805612751e6f0fcd5a2e26ec8655c6f733f79e37571721288657546.webp',
  },
  {
    templateId: '00187325-9bcb-427a-b5b5-eae00cffc39f',
    title: 'Cocktail Delivery',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/d614f7315560a66be814969e69aa03f889e1200a60348ea3d6d33e44fe5e448a1718888711739.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/d614f7315560a66be814969e69aa03f889e1200a60348ea3d6d33e44fe5e448a1718888711739.webp',
  },
  {
    templateId: 'faa3729c-7f7c-47d6-bc2a-7b0ab258ace7',
    title: 'Italian Restaurant',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/2d0c58df35a350cca61ab178c76f0e5f45efa38133af26e0d4793c34300c48781718029245660.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/2d0c58df35a350cca61ab178c76f0e5f45efa38133af26e0d4793c34300c48781718029245660.webp',
  },
  {
    templateId: '103fa193-e20b-4d2b-8415-1a771589d7eb',
    title: 'Restaurant',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/a2cecd2e05a3952c8b364d578a559c11ba48723cc34d3cccbd3c652df309573e1718888317862.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/a2cecd2e05a3952c8b364d578a559c11ba48723cc34d3cccbd3c652df309573e1718888317862.webp',
  },
  {
    templateId: 'fde59836-151d-4dc3-ae43-8f2714139c3d',
    title: 'Bar',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/6b3e9c5986a53b11cc6691e31bfcb65f7f2fbea502a16c193e3e0e57e2757c761678965804280.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/6b3e9c5986a53b11cc6691e31bfcb65f7f2fbea502a16c193e3e0e57e2757c761678965804280.webp',
  },
]

const TOYS_KIDS_BABY: TemplateItem[] = [
  {
    templateId: 'bc5e01d3-6e5f-426f-bfc3-ca558d22572e',
    title: 'Kids Clothing Store',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/b4025a7a9ae66fbaf3202d602ede1147f40995f5a8e166c51833e6e6b73ce6001703407543133.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/b4025a7a9ae66fbaf3202d602ede1147f40995f5a8e166c51833e6e6b73ce6001703407543133.webp',
  },
  {
    templateId: '5a57faf7-6941-4541-9440-e3e0d596cb2a',
    title: 'Kids Store',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/e84be9a34f3d0cdfcf9076b5e0f8ede1cf491220d66b634b797baa08b2a44eeb1729431252287.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/e84be9a34f3d0cdfcf9076b5e0f8ede1cf491220d66b634b797baa08b2a44eeb1729431252287.webp',
  },
  {
    templateId: '472919c9-149e-431f-a32f-ad234d110c18',
    title: 'Baby Gift Store',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/8d1685e94566884e2c4c9847c7a279ec25e79614532519d73b0e3789fdc16aac1703413898125.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/8d1685e94566884e2c4c9847c7a279ec25e79614532519d73b0e3789fdc16aac1703413898125.webp',
  },
  {
    templateId: '00128ef1-df7a-4d55-b8ef-50140d2bac63',
    title: 'Toy Store',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/900f721a3e9c61b98ec36be40422475b41782c0c8715154ed50430398ad1ab93.jpg/v1/fill/w_3840%2Ch_2160%2Cal_c%2Cq_90/900f721a3e9c61b98ec36be40422475b41782c0c8715154ed50430398ad1ab93.webp',
  },
  {
    templateId: '64fafbac-3afe-4c12-b52f-4aa39dfe2b2d',
    title: 'Toys Store',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/0a72bb231bc32e35485de300c9b230d9fdb4098675725cfbcdd021959dbc5421.jpg/v1/fill/w_3840%2Ch_2160%2Cal_c%2Cq_90/0a72bb231bc32e35485de300c9b230d9fdb4098675725cfbcdd021959dbc5421.webp',
  },
  {
    templateId: '422ea116-7c62-4038-a550-a027d55fe99b',
    title: 'Kids Clothing',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/524fd9fadb6047e092bbf7317497b167.jpg/v1/fill/w_3840%2Ch_2160%2Cal_c%2Cq_90/524fd9fadb6047e092bbf7317497b167.webp',
  },
]

const BOOKS_MEDIA_ART: TemplateItem[] = [
  {
    templateId: '2567700c-2268-4553-89b2-ef0c03ee8c9c',
    title: 'Artist',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/f8d6e7ffd791742b237db66f6a781b72790c9b80ab2e4f38b09293d0d4a109b21615217760551.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/f8d6e7ffd791742b237db66f6a781b72790c9b80ab2e4f38b09293d0d4a109b21615217760551.webp',
  },
  {
    templateId: 'e539b37a-e7ab-4c31-9dda-64c0809eb930',
    title: 'Artist',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/1cd210dc7e698aafb6b605130308782e429a6a67150510480eeaab9f3e6a44fd.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/1cd210dc7e698aafb6b605130308782e429a6a67150510480eeaab9f3e6a44fd.webp',
  },
  {
    templateId: 'b69eb719-eebc-4fed-8dfd-5e0957560a3e',
    title: 'Illustrator',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/812c76395651aeef38f432297ac36be50abf262d1a90db614caffb41f47f940f1663163698369.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/812c76395651aeef38f432297ac36be50abf262d1a90db614caffb41f47f940f1663163698369.webp',
  },
  {
    templateId: '81c298ba-f3ab-4fd0-a389-498a472802ae',
    title: 'Illustrator',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/6838012af7f0912388e89b260fe2bb475ecc14fa4ffc086358c54ff37aecc6131662549182925.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/6838012af7f0912388e89b260fe2bb475ecc14fa4ffc086358c54ff37aecc6131662549182925.webp',
  },
  {
    templateId: '78ad4660-914e-46a1-9aa2-f6e6f9e87533',
    title: 'Writer',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/8082f2c60a7e3e9a9b40c4fd00e0b920c042f8525b82b32d3e322f2f76639635.jpg/v1/fill/w_3840%2Ch_2160%2Cal_c%2Cq_90/8082f2c60a7e3e9a9b40c4fd00e0b920c042f8525b82b32d3e322f2f76639635.webp',
  },
  {
    templateId: '23509935-9e2e-4267-83b7-6f88d435e5ee',
    title: 'Artist',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/828091ff6a473c4efbabf5f5a0a94bd0746e1b5c84edf832d28f5e64b4b49762.jpg/v1/fill/w_3840%2Ch_2160%2Cal_c%2Cq_90/828091ff6a473c4efbabf5f5a0a94bd0746e1b5c84edf832d28f5e64b4b49762.webp',
  },
]

const SOMETHING_ELSE: TemplateItem[] = [
  {
    templateId: 'edc05836-11a9-4b85-bb3c-bc8a81b52fb8',
    title: 'AI Company',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/3b2a97a89809eaf8ef1d0260365ec60296730f21c3f65e0026b4e884a0c1c7701622022079679.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/3b2a97a89809eaf8ef1d0260365ec60296730f21c3f65e0026b4e884a0c1c7701622022079679.webp',
  },
  {
    templateId: 'e467c936-705e-41c6-9b61-cc61dedc5b31',
    title: 'Personal Blog',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/0c018f7c8c9f5adcc54531905fb2bbe2c26295f1624ea36b93708f2833e828c11628607364932.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/0c018f7c8c9f5adcc54531905fb2bbe2c26295f1624ea36b93708f2833e828c11628607364932.webp',
  },
  {
    templateId: '4b118dea-b2d2-4262-878b-e7c1c5dd4b5f',
    title: 'Locksmith',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/a713e1aa7942bf1e25a2637b9b86c3ae4575160436eef35c76eaf5ed34eaa8851680523098584.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/a713e1aa7942bf1e25a2637b9b86c3ae4575160436eef35c76eaf5ed34eaa8851680523098584.webp',
  },
  {
    templateId: '0901b198-c657-4649-8a08-f361b1b27735',
    title: 'Tech Company',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/7bc5b4dedc2e3b54249e31ce2ad6c0fb4fff80ecee9380a95e9185f63b3c14381656334241337.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/7bc5b4dedc2e3b54249e31ce2ad6c0fb4fff80ecee9380a95e9185f63b3c14381656334241337.webp',
  },
  {
    templateId: 'f4e33d91-c83d-4996-9c80-ac409acdafb6',
    title: 'Auto Insurance Agency (Dark)',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/9650b1f81db47a001ebec90db481418ef45a8250c026b162d84205d4478ba8501745313400928.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/9650b1f81db47a001ebec90db481418ef45a8250c026b162d84205d4478ba8501745313400928.webp',
  },
  {
    templateId: '2fe0177d-dcb6-45de-ad21-ba4c157810b7',
    title: 'Handyman (Classic)',
    imageUrl:
      'https://images-wixmp-530a50041672c69d335ba4cf.wixmp.com/templates/image/83afc10385adfc70b0a01b6736d15b5e7b56ad0e0b10c8694efa8a95d770938d1751469000448.jpg/v1/fill/w_1920%2Ch_1080%2Cal_c%2Cq_90/83afc10385adfc70b0a01b6736d15b5e7b56ad0e0b10c8694efa8a95d770938d1751469000448.webp',
  },
]

// Mocked templates data per category
export const templatesMap: Record<string, TemplateItem[]> = {
  fashion_apparel: FASHION_APPAREL,
  beauty_personal_care: BEAUTY_AND_HAIR,
  home_living: HOME_LIVING,
  electronics_gadgets: ELECTRONICS_GADGETS,
  sports_outdoors: SPORTS_OUTDOORS,
  food_beverages: FOOD_BEVERAGES,
  toys_kids_baby: TOYS_KIDS_BABY,
  books_media_art: BOOKS_MEDIA_ART,
  something_else: SOMETHING_ELSE,
}
